<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
  <BackgroundImage />
  <DocumentLink />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- 削除 -->
    <transition name="popup">
      <PCViewLaterDeleteConfirm
        v-if="state.visibleViewLaterDeleteConfirm"
        @closeViewLaterDeleteConfirm="state.visibleViewLaterDeleteConfirm = false"
      />
    </transition>

    <!-- 一括削除 -->
    <transition name="popup">
      <PCViewLaterDeleteInBulkConfirm
        v-if="state.visibleViewLaterDeleteInBulkConfirm"
        @closeViewLaterDeleteInBulkConfirm="state.visibleViewLaterDeleteInBulkConfirm = false"
      />
    </transition>

    
    <!-- 後で見る -->
    <!-- <transition name="toast">
      <PCBasicToast v-if="state.visibleToast" @closeToast="state.visibleToast = false">「設問」を後で見るに保存しました。</PCBasicToast>
    </transition> -->

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
        <form action="" method="post" class="header-search">
          <div class="header-search-title">後で見る</div>
        </form>
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <main class="" id="main">
          <div class="box02 white">
            <div class="box02-hdg">
              <h1 class="box02-hdg-title hdg03">後で見る</h1>
              <template  v-if="data.count !== null && data.count !== 0">
                <span class="box02-hdg-title-sup">{{data.count}}件</span>
                <div class="box02-hdg-aside">
                  <span role="button" class="box02-hdg-aside-menu"
                    @click="state.visibleViewLaterDeleteInBulkConfirm =  true"
                  >一括削除</span>
                </div>
              </template>
            </div>
            <PCScrollList
              :complete="data.complete"
              @bottomDisplayed="action.load"
              @scroll="handleScroll"
              >
              <p v-if="data.complete && data.count <= 0"  class="txt pt32 pb32 pl40 pr40">後で見るは登録されていません。</p>
              <template v-for="(dateLists, index) in data.groupDateLists">
                <div :key="'viewlater_date_' + index" class="date">{{formatDate(index)}}</div>
                <ul :key="'viewlater_lists_' + index" class="list-result list-result-small">
                  <li v-for="(list, dateIndex) in dateLists" :key="'date_'+ index + 'list' + dateIndex" class="list-result-item">
                    <div class="list-result-item-main">
                      <template v-if="list.deleted == 1">
                        <div class="list-result-message">閲覧できなくなりました。</div>
                        <div class="list-result-title"><span class="is-inactive">{{list.title}}</span></div>
                      </template>
                      <template v-else-if="list.auth_message">
                        <div class="list-result-message">{{list.auth_message}}</div>
                        <div class="list-result-title"><span class="is-inactive">{{list.title}}</span></div>
                      </template>
                      <template v-else>
                        <!-- <div v-if="list.type == 'qa' && list.latest_id !== 0" class="list-result-message">更新されました。</div> -->
                        <div class="list-result-title"><a @click="action.routeList(list)" role="button">{{list.title}}</a></div>
                      </template>
                      <div class="list-result-note mb0" v-if="list.type == 'qa'">
                        <span class="list-result-sup">Q&A・事例</span>
                        <span v-if="list.deleted !== 1" class="list-result-sup">{{list.book_name}}</span>
                        <span v-if="list.year && list.year !== 'マスターインデックス'" class="list-result-sup">{{list.year}}</span>
                      </div>
                      <div class="list-result-note mb0" v-else-if="list.type == 'knowledge'">
                        <span class="list-result-sup"><span class="category-item">最新ナレッジ</span><span class="category-item">{{list.knowledge_type_name}}</span></span>
                        <span class="list-result-sup">{{formatDate(list.content_created)}}</span>
                      </div>
                      <div class="list-result-note mb0" v-else-if="list.type == 'pj'">
                        <span class="list-result-sup">資料</span>
                        <span v-if="list.deleted !== 1" class="list-result-sup">{{list.book_name}}</span>
                      </div>
                    </div>
                    <div @click="action.deleteItem(list.bookmark_id)"><ButtonClose /></div>
                  </li>
                </ul>
              </template>
            </PCScrollList>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'

import { ViewLater } from '@/logic/viewlater/ViewLater'

import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCViewLaterDeleteConfirm from '@/components/pc/popup/PCViewLaterDeleteConfirm.vue'
import PCViewLaterDeleteInBulkConfirm from '@/components/pc/popup/PCViewLaterDeleteInBulkConfirm.vue'
import PCBasicToast from '@/components/pc/popup/PCBasicToast.vue'
import PCScrollList from '@/components/pc/partial/PCScrollList.vue'

export default defineComponent({
  components: {
    PCMenu,
    PCViewLaterDeleteConfirm,
    PCViewLaterDeleteInBulkConfirm,
    PCBasicToast,
    PCScrollList
  },  
  setup (props, context) {
    return { ...ViewLater(props, context) }
  }
})
</script>

<style lang="scss" scoped>
#main {
  width: 100%;
  margin-left: 0;
}
.box02-body {
  overflow: auto;
  .date {
    color: #ccc;
    display: block;
    padding: 40px 40px 0;
  }
}
.list-result {
  &-item {
    .category-item:not(:last-child) {
      margin-right: 1em;
    }
  }
}
</style>
